module.exports = __webpack_public_path__ + "img/join-us-12.d25a98bc.png";